module.exports = __webpack_public_path__ + "img/1440.8d977d73.jpg";